/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { InventorySyncReconciliationResultDTO } from '../model/inventorySyncReconciliationResultDTO';
// @ts-ignore
import { InventorySyncReconciliationTriggerRequestDTO } from '../model/inventorySyncReconciliationTriggerRequestDTO';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class InventorySyncReconciliationControllerService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Manually trigger inventory sync reconciliation
     * Replays persisted failed/retry-pending inventory sync operations and sweeps cancelled orders without a cancellation inventory sync. Each run processes at most operationBatchSize (default inventory.sync.reconciliation.operation-batch-size) operations and orphanBatchSize (default inventory.sync.reconciliation.orphan-batch-size) orphan orders; remaining backlog is drained by subsequent scheduled runs or additional manual triggers. Use operationsOnly / orphansOnly / innerOrderNo to narrow scope.
     * @param inventorySyncReconciliationTriggerRequestDTO 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public triggerReconciliation(inventorySyncReconciliationTriggerRequestDTO?: InventorySyncReconciliationTriggerRequestDTO, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<InventorySyncReconciliationResultDTO>;
    public triggerReconciliation(inventorySyncReconciliationTriggerRequestDTO?: InventorySyncReconciliationTriggerRequestDTO, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InventorySyncReconciliationResultDTO>>;
    public triggerReconciliation(inventorySyncReconciliationTriggerRequestDTO?: InventorySyncReconciliationTriggerRequestDTO, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InventorySyncReconciliationResultDTO>>;
    public triggerReconciliation(inventorySyncReconciliationTriggerRequestDTO?: InventorySyncReconciliationTriggerRequestDTO, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (BearerAuthentication) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuthentication', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            '*/*'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/inventory-sync/reconciliation/trigger`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<InventorySyncReconciliationResultDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: inventorySyncReconciliationTriggerRequestDTO,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
